<template>
  <div
    class="content-container"
    :style="containerStyles">
    <router-view class="tab-router" />
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data: () => ({
    containerStyles: {}
  }),

  name: 'content-container',

  computed: {
    ...mapState({
      styles: state => state.contentContainer.styles
    })
  },

  methods: {
    refreshStyles () {
      let padding = this.styles.padding || '0'

      this.containerStyles = {
        padding: padding + 'px',
        height: 'calc(100% - ' + (padding * 2) + 'px)'
      }
    }
  },

  mounted () {
    this.refreshStyles()
  },

  watch: {
    '$route.name' () {
      // this has to be set on the event loop to force refresh
      // new style on route changes
      setTimeout(() => {
        this.refreshStyles()
      }, 0)
    }
  }
}
</script>

<style lang="scss">
  .content-container {
    flex: 1;
    display: flex;
    flex-direction: column;
    position: relative;
  }
</style>
